import { Component } from "@angular/core";

@Component({
  selector: "toolbox-tab-menu",
  templateUrl: "./tab-menu.component.html",
  styleUrls: ["./tab-menu.component.scss"],
})
export class TabMenuComponent {
  orientations = [
    "left",
    "top",
    "bottom",
    "right",
  ];

  trackByIndex(index, item) {
    return index;
  }
}
